import React, { createContext, useContext } from "react";
import { useExportJobs } from "./useExportJobs";

const ExportJobsContext = createContext(null);

/**
 * Mounts the polling hook once at the Layout level so toasts fire on every
 * page. MyDownloadsPage consumes this context instead of calling the hook
 * directly — avoids duplicate polling and duplicate toasts.
 */
export const ExportJobsProvider = ({ children }) => {
    const value = useExportJobs();
    return (
        <ExportJobsContext.Provider value={value}>
            {children}
        </ExportJobsContext.Provider>
    );
};

export const useExportJobsContext = () => {
    const ctx = useContext(ExportJobsContext);
    if (!ctx) throw new Error("useExportJobsContext must be used inside ExportJobsProvider");
    return ctx;
};
